var LAST_KNOWN_SHOP_COMPONENTS_VERSION_KEY = 'nike-shop-components-last-known-version';
export var SHOP_COMPONENTS_VERSION_READY_EVENT = 'nike-shop-components-version-ready';
var getStorage = function getStorage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    storage = _ref.storage;
  if (storage !== undefined) {
    return storage;
  }
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.localStorage;
};
export var getShopComponentsRuntimeVersion = function getShopComponentsRuntimeVersion() {
  var _window$NikeShop;
  if (typeof window === 'undefined') {
    return undefined;
  }
  return ((_window$NikeShop = window.NikeShop) === null || _window$NikeShop === void 0 ? void 0 : _window$NikeShop.version) || window.NikeShopClientVersion;
};
export var getLastKnownShopComponentsVersion = function getLastKnownShopComponentsVersion() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    storage = _ref2.storage;
  try {
    var _getStorage;
    return ((_getStorage = getStorage({
      storage: storage
    })) === null || _getStorage === void 0 ? void 0 : _getStorage.getItem(LAST_KNOWN_SHOP_COMPONENTS_VERSION_KEY)) || undefined;
  } catch (error) {
    return undefined;
  }
};
export var setLastKnownShopComponentsVersion = function setLastKnownShopComponentsVersion() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    storage = _ref3.storage,
    version = _ref3.version;
  if (!version) {
    return;
  }
  try {
    var _getStorage2;
    (_getStorage2 = getStorage({
      storage: storage
    })) === null || _getStorage2 === void 0 || _getStorage2.setItem(LAST_KNOWN_SHOP_COMPONENTS_VERSION_KEY, version);
  } catch (error) {
    // localStorage can be unavailable in privacy modes; cache busting still has fallbacks.
  }
};
export var getShopComponentsVersionForQueryCache = function getShopComponentsVersionForQueryCache() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    storage = _ref4.storage;
  return getShopComponentsRuntimeVersion() || getLastKnownShopComponentsVersion({
    storage: storage
  });
};